import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

export interface IVetLiveVideoSubscriptionCheckStatus {
  eventId: string;
  isSubscribed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LiveVideoSubscriptionService {
  private apiUrl = `${environment.baseApimUrl}/vet-live-video-subscription`;

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) {}

  subscribe(videoIds: string[]): Observable<void> {
    const payload = {
      videoIds,
      veterinarianId: this.authService.getUserId()
    };
    return this.http.post<void>(this.apiUrl, payload);
  }

  checkSubscription(
    videoIds: string[]
  ): Observable<IVetLiveVideoSubscriptionCheckStatus[]> {
    const payload = {
      veterinarianId: this.authService.getUserId(),
      videoIds
    };
    return this.http.post<IVetLiveVideoSubscriptionCheckStatus[]>(
      `${this.apiUrl}/check`,
      payload
    );
  }
}
